// Regras de senha — espelham UserService.validatePassword (backend).
// Manter idêntico ao backend: se as regras divergirem, a tela aceita uma senha
// que o servidor recusa (ou o contrário). Em especial, o conjunto de caracteres
// especiais é o mesmo do backend, incluindo `:`.

export interface PasswordRequirements {
  minLength: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}

export const evaluatePassword = (password: string): PasswordRequirements => ({
  minLength: password.length >= 8,
  hasUpperCase: /[A-Z]/.test(password),
  hasLowerCase: /[a-z]/.test(password),
  hasNumber: /[0-9]/.test(password),
  hasSpecialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
});

export const isPasswordValid = (password: string): boolean =>
  Object.values(evaluatePassword(password)).every(Boolean);

export const PASSWORD_RULE_LABELS: Record<keyof PasswordRequirements, string> = {
  minLength: 'Mínimo de 8 caracteres',
  hasUpperCase: 'Pelo menos uma letra maiúscula (A-Z)',
  hasLowerCase: 'Pelo menos uma letra minúscula (a-z)',
  hasNumber: 'Pelo menos um número (0-9)',
  hasSpecialChar: 'Pelo menos um caractere especial (!@#$%)',
};
